import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import * as Yup from 'yup';
import { Dialog } from '../../../../../../components/Dialog';
import { ChargePointSerialGraphic } from '../../../../../../design-system';
import { createSchema, type FormFields } from '../../../../../../utils/formUtils';
import type { DetailsEvnex } from '../types';
import { DetailsStepForm } from './DetailsStepForm';

const DialogContext = React.createContext({ toggle: () => {} });

const fields: FormFields<DetailsEvnex, React.ReactNode> = {
  serial: {
    id: 'serial',
    label: 'Serial',
    inputProps: {
      helperText: (
        <DialogContext.Consumer>
          {({ toggle }) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid -- Component has been set to "button".
            <Link component="button" variant="body2" onClick={toggle}>
              Where do I find my charge point serial?
            </Link>
          )}
        </DialogContext.Consumer>
      ),
    },
  },
};

const validationSchema = createSchema<DetailsEvnex>({
  serial: Yup.string()
    .required('Serial is required')
    // eslint-disable-next-line no-template-curly-in-string --- Yup messages can be customised using template curlies in strings.
    .max(80, 'Serial must be at most ${max} characters')
    .matches(/^[a-zA-Z0-9-_]*$/, 'Serial may only include numbers, letters, "-" and "_" characters'),
});

export const DetailsEvnexStep: React.FC = () => {
  const [isOpen, setIsOpen] = React.useState(false);

  const toggle = React.useCallback(() => setIsOpen((prev) => !prev), []);

  return (
    <DialogContext.Provider value={{ toggle }}>
      <DetailsStepForm fields={fields} initialValues={{ serial: '' }} validationSchema={validationSchema} />
      {/* Where do I find my charge point serial dialog */}
      <Dialog
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title="Where do I find my charge point serial?"
        maxWidth="xs"
      >
        <Box px={2}>
          <ChargePointSerialGraphic
            mb={4}
            textAlign="center"
            svgProps={{ style: { maxWidth: '60%', height: '100%' } }}
          />
          <Typography variant="body2" paragraph>
            A charge point serial is a unique alphanumeric code that identifies your charge point.
          </Typography>
          <Typography variant="body2" paragraph>
            You can find it on your Evnex charge point&apos;s label, in the bottom left corner.
          </Typography>
        </Box>
      </Dialog>
    </DialogContext.Provider>
  );
};
